export class ListAzureFileShares200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fileShares",
            "baseName": "fileShares",
            "type": "Array<ListAzureFileShares200ResponseFileSharesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureFileShares200Response.attributeTypeMap;
    }
    constructor() {
    }
}
